import {useEffect} from "react";
import {CommentTextarea, Username} from "@crunchyroll/cx-web-components";
import {useContext, useState} from "react";
import {useUser} from "../../user/hooks";
import {createComment} from "../requests";
import GuestbookContext from "../context/GuestbookContext";
import {getBasename} from "../../../helpers/routingHelpers";

import styles from "./CommentTextareaWrapper.module.scss";
import {LANGUAGES_BY_BASENAME} from "../../../constants/languages";
import {useComments} from "../hooks/useComments";

const PROFILE_STATUS_PREMIUM = "PREMIUM";

const CommentTextareaWrapper = ({className}) => {
  const locale = LANGUAGES_BY_BASENAME[getBasename()].key;
  const {avatarSrc, username, isPremium} = useUser();
  const {guestbookKey, increaseTotalComments} = useContext(GuestbookContext);
  const {addComment} = useComments();

  const [isExpanded, setIsExpanded] = useState(false);
  const [text, setText] = useState("");
  const [isSpoiler, setIsSpoiler] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [canSubmit, setCanSubmit] = useState(false);

  useEffect(() => {
    setCanSubmit(Boolean(text));
  }, [text]);

  const onCheckboxChange = ({target: {checked}}) => {
    setIsSpoiler(checked);
  };

  const onTextareaFocus = () => {
    if (!isExpanded) {
      setIsExpanded(true);
    }
  };

  const onTextareaChange = ({target: {value}}) => {
    setText(value);
  };

  const onSubmitClick = () => {
    setIsLoading(true);

    createComment({
      guestbook_key: guestbookKey,
      message: text,
      locale,
    })
      .then(newComment => {
        addComment(newComment);
        increaseTotalComments();
        onCancelClick();
      })
      .catch(error => {
        console.err(error);
      })
      .then(() => {
        setIsLoading(false);
      });
  };

  const onCancelClick = () => {
    setIsExpanded(false);
    setText("");
    setIsSpoiler(false);
  };

  return (
    <CommentTextarea
      className={`${className} ${styles.commentTextarea}`}
      avatar={avatarSrc}
      username={
        <Username
          status={isPremium ? PROFILE_STATUS_PREMIUM : undefined}
          size="m"
        >
          {username}
        </Username>
      }
      isExpanded={isExpanded}
      text={text}
      isSpoiler={isSpoiler}
      onTextareaFocus={onTextareaFocus}
      onTextareaChange={onTextareaChange}
      onSubmitClick={onSubmitClick}
      onCheckboxChange={onCheckboxChange}
      onCancelClick={onCancelClick}
      canSubmit={canSubmit}
      isLoading={isLoading}
    />
  );
};

export default CommentTextareaWrapper;
